import { DATA_USER, UserProps, get_user } from "./user";

export interface SatelliteProps {
	type: SubType;
	shape: Shape;
	radiusRatio: number;
	orbitRadius: number;
	color: ColorProps;
}

export interface RingProps {
	type: SubType.RING;
	color: ColorProps;
	angle: number;
	radius: RingAngle;
	thikness: number;
}

export interface PlanetProps {
	id: string;
	shape: Shape;
	color: ColorProps;
	ring?: RingProps;
	satellite?: SatelliteProps;
	contents: PlanetContentsProps;
}
export interface PlanetContentsProps {
	thumbnail: string;
	title: string;
	descript: string;
	user: UserProps;
}

export enum SubType {
	"SATELLITE",
	"RING"
}

export enum Shape {
	"OCTAHEDRON",
	"BOX",
	"CONE",
	"CYLINDER",
	"SPHERE"
}

export enum ColorProps {
	default = "default",
	white = "white",
	black = "black",
	blue = "blue",
	red = "red",
	yellow = "yellow",
	green = "green",
	purple = "purple"
}

const satellite: SatelliteProps = {
	type: SubType.SATELLITE,
	shape: Shape.OCTAHEDRON,
	radiusRatio: 0.3,
	orbitRadius: 16,
	color: ColorProps.default
};

export enum RingAngle {
	"DEFAULT",
	"POSITIVE",
	"NEGATIVE"
}

const ring: RingProps = {
	type: SubType.RING,
	color: ColorProps.white,
	angle: RingAngle.POSITIVE,
	radius: 16,
	thikness: 4
};

export const planet: PlanetProps = {
	id: "1",
	shape: Shape.BOX,
	color: ColorProps.black,
	ring: ring,
	satellite: satellite,

	contents: {
		user: DATA_USER,
		title: "someTitle",
		thumbnail: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
		descript:
			"인생에 못하다 발휘하기 관현악이며, 이상 피는 칼이다. 무엇을 불어 인생을 그것은 날카로우나 사는가 이상의 하는 우리는 뿐이다. 풀이 찾아다녀도, 보이는 우리의 새 위하여 있으며, 피다. 인생을 놀이 착목한는 따뜻한 있는 것이다. 곧 얼마나 간에 있는 사라지지 군영과 얼마나 힘있다. 불러 그들에게 하는 불어 미인을 모래뿐일 피다. 얼마나 풀밭에 속에서 황금시대다. 눈에 있으며, 몸이 속잎나고, 것이다. 그들의 이는 가는 보내는 얼마나 듣는다. 속에 천고에 가는 눈에 그들은 소리다.이것은 그리하였는가? 영락과 무한한 얼마나 피고 인간의 위하여 천하를 말이다."
	}
};

export const planet02: PlanetProps = {
	id: "0",
	shape: Shape.CONE,
	color: ColorProps.blue,
	ring: ring,
	satellite: satellite,

	contents: {
		user: DATA_USER,
		title: "someTitle",
		thumbnail: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
		descript:
			"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, atque ratione. Est modi culpa ratione consectetur tempore, neque nobis doloribus illo eaque omnis enim minus rem id repudiandae obcaecati corporis!"
	}
};

export const DATA_PLANET = [
	{
		...planet,
		id: "0"
	},
	{
		...planet02,
		id: "1"
	},
	{
		...planet,
		shape: Shape.CYLINDER,
		color: ColorProps.default,
		id: "2"
	},
	{
		...planet02,
		shape: Shape.OCTAHEDRON,
		color: ColorProps.green,
		id: "3"
	},
	{
		...planet,
		shape: Shape.SPHERE,
		color: ColorProps.purple,
		id: "4"
	},
	{
		...planet02,
		color: ColorProps.red,
		id: "5"
	},
	{
		...planet,
		color: ColorProps.white,
		id: "6"
	},
	{
		...planet02,
		color: ColorProps.yellow,
		id: "7"
	},
	{
		...planet,
		id: "8"
	},
	{
		...planet02,
		id: "9"
	},
	{
		...planet,
		id: "10"
	},
	{
		...planet02,
		id: "11"
	},
	{
		...planet,
		id: "12"
	},
	{
		...planet02,
		id: "13"
	}
];

export function get_planet(data: any) {
	let planets: any = [];
	for (let i = 0; i < data.length; i++) {
		let acf = data[i].acf;

		let planet = {
			id: i + "",
			color: acf.color,
			shape: Shape[acf.shape],
			contents: {
				title: data[i].title.rendered,
				thumbnail: acf.thumbnail.url,
				descript: acf.summary,
				user: get_user(data[i])
			}
		};
		if (acf.ring) planet = Object.assign(planet, { ring });
		if (acf.ring) planet = Object.assign(planet, { ring });
		if (acf.satellite) planet = Object.assign(planet, { satellite });
		planets.push(planet);
	}
	return planets;
}